import request from "@/utils/request";

export function getNotifications(page =1) {
    return request({
        url: "/notification/list",
        method: "get",
        params: {
            page
        }
    });
}

export function getLastNotifications() {
    return request({
        url: "/notification",
        method: "get",
    });
}

